import {
  OverlayArrow,
  Popover as AriaPopover
} from 'react-aria-components';

export function Popover({ children, hideArrow, ...props }) {
  return (
    <AriaPopover {...props} className={`bg-white shadow-xl rounded-lg border border-gray-200 p-4 focus:outline-none focus-visible:ring-0 ${props.className || ''}`}>
      {({trigger}) => <>
        {!hideArrow && trigger !== 'MenuTrigger' && trigger !== 'SubmenuTrigger' && (
          <OverlayArrow>
            <svg width={12} height={12} viewBox="0 0 12 12" className="block fill-white stroke-gray-200 stroke-2">
              <path d="M0 0 L6 6 L12 0" />
            </svg>
          </OverlayArrow>
        )}
        {children}
      </>}
    </AriaPopover>
  );
}
